<form [formGroup]="frmSignup" (submit)="insertOrUpdateUser();">
  <p-dialog [modal]="true" header="Gestion utilisateur" [(visible)]="isVisible" (onHide)="setVisible(false)" >
      <div class="p-grid" style="padding: 15px 30px;">
          <div class="p-col-12">
            <label for="matricule" >Matricule :</label>
            <input type="text" formControlName="matricule" pInputText id="matricule" placeholder="Matricule" [(ngModel)]="data.matricule" style="width: 100%;margin-top: 5px;">
          </div>
        <!--   ERREUR OBLIGATION MATRICULE  -->
        <div class="p-col-12">
          <label class="text-danger" *ngIf="frmSignup.controls['matricule'].hasError('required') "
                 [ngClass]="frmSignup.controls['matricule'].hasError('required')  ? 'invalid-error' : 'valided-error'">
            Le matricule est obligatoire!
          </label>
        </div>
          <div class="p-col-12">
              <label for="nom" >Nom :</label>
              <input type="text" formControlName="nom" pInputText id="nom" placeholder="Nom" [(ngModel)]="data.nom" style="width: 100%;margin-top: 5px;">
          </div>

          <div class="p-col-12">
              <label for="prenom" >Prénom :</label>
              <input type="text" formControlName="prenom" pInputText id="prenom" placeholder="Prénom" [(ngModel)]="data.prenom" style="width: 100%;margin-top: 5px;">
          </div>
        <!--  EMAIL -->
        <div class="p-col-12">
          <label for="email">Email :</label>
          <input type="text" formControlName="email" pInputText id="email" placeholder="Mail" [(ngModel)]="data.email" style="width: 100%;margin-top: 5px;">
        </div>
        <div class="p-col-12" *ngIf="data.id ==0" [ngClass]="frmSignup.controls['email'].hasError('invalidMail')
           ? 'invalid-error' : 'valided-error'">
          <label class="col">
            Le format email est invalide!
          </label>
        </div>
        <!-- GESTION DROIT-->
        <div class="p-col-12">
          <label for="droit">Droit :</label>
          <p-dropdown id="droit" formControlName="droit" (onChange)="checkEtatClient()" [style]="{'width':'100%', 'margin-top': '5px'}" [options]="droits" [(ngModel)]="selectedDroit" appendTo="body" placeholder="Choisissez un droit"></p-dropdown>
        </div>
        <!-- GESTION MOT DE PASSE -->
          <div class="p-col-12" *ngIf="data.id ==0 && !isClient">
            <label for="password" [ngClass]="frmSignup.controls['password'].invalid ? '' : ''">Mot de passe :</label>
            <input type="password" formControlName="password" pInputText id="password" placeholder="Mot de passe" [(ngModel)]="data.mot_de_passe"
                   [ngClass]="frmSignup.controls['password'].invalid ? 'is-invalid' : ''"  style="width: 100%;margin-top: 5px;">
          </div>
        <!-- DEBUT LISTE ERREUR VALIDATION MOT De PSSE -->
        <div class="p-col-12" *ngIf="data.id ==0 && !isClient" [ngClass]="frmSignup.controls['password'].hasError('required')
          || frmSignup.controls['password'].hasError('minlength')  ? 'invalid-error' : 'valided-error'">
          <label class="col">
            Doit comporter au moins 8 caractères!
          </label>
        </div>
        <div class="p-col-12" *ngIf="data.id ==0 && !isClient" [ngClass]="frmSignup.controls['password'].hasError('required')
          || frmSignup.controls['password'].hasError('hasNumber')  ? 'invalid-error' : 'valided-error'">
          <label class="col" >
            Doit contenir au moins un chiffre!
          </label>
        </div>
          <div class="p-col-12" *ngIf="data.id ==0 && !isClient" [ngClass]="frmSignup.controls['password'].hasError('required')
          || frmSignup.controls['password'].hasError('hasCapitalCase')  ? 'invalid-error' : 'valided-error'">
            <label class="col" >
              Doit contenir au moins 1 dans Capital Case!
            </label>
          </div>
          <div class="p-col-12" *ngIf="data.id ==0 && !isClient" [ngClass]="frmSignup.controls['password'].hasError('required')
          || frmSignup.controls['password'].hasError('hasSmallCase')  ? 'invalid-error' : 'valided-error'">
            <label class="col" >
              Doit contenir au moins 1 lettre en petit cas!
            </label>
          </div>
          <div class="p-col-12" *ngIf="data.id ==0 && !isClient" [ngClass]="frmSignup.controls['password'].hasError('required')
           || frmSignup.controls['password'].hasError('hasSpecialCharacters') ? 'invalid-error' : 'valided-error'">
            <label class="col" >
              Doit contenir au moins 1 caractère spécial!
            </label>
          </div>
          <div class="p-col-12" *ngIf="data.id ==0 && !isClient">
            <label for="confirmPassword" >Confirmer le mot de passe :</label>
            <input type="password" formControlName="confirmPassword" pInputText id="confirmPassword" placeholder="Mot de passe"
                   [ngClass]="frmSignup.controls['confirmPassword'].invalid ? 'is-invalid' : ''"
                   style="width: 100%;margin-top: 5px;">
          </div>
          <div class="p-col-12" *ngIf="frmSignup.controls['confirmPassword'].hasError('required') && data.id ==0 && !isClient" [ngClass]="frmSignup.controls['confirmPassword'].hasError('required')  ?
          'invalid-error' : 'valided-error'">
            <label class="text-danger" >
              Le mot de passe est obligatoire!
            </label>
          </div>
          <div class="p-col-12" *ngIf="frmSignup.controls['confirmPassword'].hasError('NoPassswordMatch') && data.id ==0 && !isClient" [ngClass]="frmSignup.controls['confirmPassword'].hasError('NoPassswordMatch')  ? 'invalid-error' : 'valided-error'">
            <label class="text-danger" >
              Les mots de passe ne correspond pas. Veuillez réessayer!
            </label>
          </div>
      </div>
      <p-footer>
          <button *ngIf="data.id ==0" [disabled]="(frmSignup.invalid && data.id ==0) && !isClient" type="submit" pButton icon="pi pi-plus-circle" label="Ajouter" class="ui-button-success  btn-footer"></button>
          <button *ngIf="data.id !=0" [disabled]="(frmSignup.invalid && data.id ==0)" type="submit" pButton icon="pi pi-plus-circle" label="Modifier" class="ui-button-success  btn-footer"></button>
          <button type="button" pButton icon="pi pi-times" (click)="isVisible=false" label="Annuler" class="ui-button-secondary btn-footer"></button>
      </p-footer>
  </p-dialog>
</form>
